const safeLocalStorage = {
  /**
   * Retrieves an item from localStorage
   * @param {string} key - The key to retrieve
   * @param {any} defaultValue - Default value if key doesn't exist or error occurs
   * @returns {any} The retrieved value or defaultValue
   */
  getItem(key, defaultValue = null) {
    try {
      const value = window?.localStorage?.getItem(key)
      return value ?? defaultValue
    } catch (error) {
      console.error('Local Storage access error:', { key, error })
      return defaultValue
    }
  },

  /**
   * Sets an item in localStorage
   * @param {string} key - The key to set
   * @param {any} value - The value to store
   * @returns {boolean} Success status
   */
  setItem(key, value) {
    try {
      const stringValue = typeof value === 'string' ? value : JSON.stringify(value)

      window?.localStorage?.setItem(key, stringValue)
      return true
    } catch (error) {
      console.error('Local Storage access error:', { key, error })
      return false
    }
  },

  /**
   * Removes an item from localStorage
   * @param {string} key - The key to remove
   * @returns {boolean} Success status
   */
  removeItem(key) {
    try {
      window?.localStorage?.removeItem(key)
      return true
    } catch (error) {
      console.error('Local Storage access error:', { key, error })
      return false
    }
  },
}

export { safeLocalStorage as default }
